import { useEffect } from "react";
import {
    NotificationManager,
  } from "react-notifications";

export const createNotificationPlanner = (type) => {

    return () => {
      switch (type) {
        case "info":
          NotificationManager.info("Planner has submitted a new task list. Check your recent task list");
          break;
        case "success":
          NotificationManager.success("Success message", "Title here");
          break;
        case "warning":
          NotificationManager.warning(
            "Warning message",
            "Close after 3000ms",
            3000
          );
          break;
        case "error":
          NotificationManager.error("Error message", "Click me!", 5000, () => {
            alert("callback");
          });
          break;
        default:
          break;
      }
    };
  };

  export const createNotificationSupervisor = (type) => {
    return () => {
      switch (type) {
        case "info":
          NotificationManager.info("Your Project Status Has Been Changed Recently. Check Your Current Project");
          break;
        case "success":
          NotificationManager.success("Success message", "Title here");
          break;
        case "warning":
          NotificationManager.warning(
            "Warning message",
            "Close after 3000ms",
            3000
          );
          break;
        case "error":
          NotificationManager.error("Error message", "Click me!", 5000, () => {
            alert("callback");
          });
          break;
        default:
          break;
      }
    };
  };